import React from 'react'
// import InputColor from 'react-input-color'

const ColorsSection = ({ title, value, colors, config, onClick }) => (
  <ul className="list-group unbordered unstriped">
    <li className="list-group-item text-bold">{title}</li>
    <li className="list-group-item list-group-item-colors">
      <div className="row">
        <div className="col">
          {/* <InputColor
            initialValue={value}
            onChange={e => onClick(config, e.hex)}
            placement="top"
          /> */}
          {colors.map((color, i) => (
            <div
              key={i}
              className={`color-block color-${color} bg-${color}`}
              onClick={() => onClick(config, color)}
            />
          ))}
        </div>
      </div>
    </li>
  </ul>
)

export default ColorsSection
